import {
  ACCESS_TOKEN_STORAGE_KEY,
  CURRENT_PROJECT_UUID_STORAGE_KEY,
  LANGUAGE_STORAGE_KEY,
  REFRESH_TOKEN_STORAGE_KEY,
} from "../constants/local-storage";

export interface IStorageAdapter {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export class StorageService {
  private adapter: IStorageAdapter;

  constructor(adapter: IStorageAdapter) {
    this.adapter = adapter;
  }

  getToken(): string | null {
    return this.adapter.getItem(ACCESS_TOKEN_STORAGE_KEY);
  }

  setToken(token: string): void {
    this.adapter.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
  }

  getRefreshToken(): string | null {
    return this.adapter.getItem(REFRESH_TOKEN_STORAGE_KEY);
  }

  setRefreshToken(token: string): void {
    this.adapter.setItem(REFRESH_TOKEN_STORAGE_KEY, token);
  }

  getLanguage(): string | null {
    return this.adapter.getItem(LANGUAGE_STORAGE_KEY);
  }

  setLanguage(language: string): void {
    this.adapter.setItem(LANGUAGE_STORAGE_KEY, language);
  }

  getProjectUuid(): string | null {
    return this.adapter.getItem(CURRENT_PROJECT_UUID_STORAGE_KEY);
  }

  clearStorage(): void {
    this.adapter.removeItem(ACCESS_TOKEN_STORAGE_KEY);
    this.adapter.removeItem(REFRESH_TOKEN_STORAGE_KEY);
    this.adapter.removeItem(CURRENT_PROJECT_UUID_STORAGE_KEY);
  }
}
